import React, { useCallback, useEffect, useRef, useState } from 'react';
import { LoginFormModal } from '../../../../../LoginPage';
import { APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT } from '@shared/api/apollo';
import { useIsMobile } from '../../../../../utils';
import { useTranslation } from 'react-i18next';
// tslint:disable-next-line:import-blacklist
import { useLocation } from 'react-router-dom';
import { useHistory } from '@shared/routing';
import { extractOrderIdFromPathname } from '@shared/lib/order';
const AuthRequiredForSecondaryOps = () => {
    const { t } = useTranslation('LoginPage');
    const history = useHistory();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const needReloadRef = useRef(true);
    // FIXME: WEBSKY-7854: временно скрываем логику повторного запроса
    // const [pendingOperation, setPendingOperation] = useState<Operation | null>(null);
    // const client = useApolloClient();
    const isMobile = useIsMobile();
    useEffect(() => {
        const eventHandler = (event) => {
            if (event.detail) {
                // FIXME: WEBSKY-7854: временно скрываем логику повторного запроса
                // setPendingOperation(event.detail.operation);
                setIsOpen(true);
            }
        };
        document.addEventListener(APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT, eventHandler);
        return () => document.removeEventListener(APOLLO_AUTH_REQUIRED_FOR_SECONDARY_OPS_EVENT, eventHandler);
    }, []);
    // FIXME: WEBSKY-7854: временно скрываем логику повторного запроса
    // const onSuccessfulLogin = useCallback(async () => {
    // 	setIsOpen(false);
    // 	if (pendingOperation) {
    // 		// Повторяем запрос после успешной авторизации
    // 		try {
    // 			const { query, variables } = pendingOperation;
    // 			// Определяем тип операции (query или mutation)
    // 			const definition = pendingOperation.query?.definitions?.[0];
    // 			const operationType = definition && 'operation' in definition ? definition.operation : 'query';
    // 			if (operationType === 'mutation') {
    // 				await client.mutate({
    // 					mutation: query,
    // 					variables: variables,
    // 					fetchPolicy: 'no-cache'
    // 				});
    // 			} else {
    // 				await client.query({
    // 					query: query,
    // 					variables: variables,
    // 					fetchPolicy: 'network-only'
    // 				});
    // 			}
    // 		} catch (error) {
    // 			// Если после авторизации запрос снова вернул ошибку,
    // 			// событие будет отправлено снова и модалка откроется
    // 			console.error('Error retrying operation after auth:', error);
    // 		} finally {
    // 			setPendingOperation(null);
    // 		}
    // 	}
    // }, [client, pendingOperation]);
    const onClose = useCallback(() => {
        // FIXME: WEBSKY-7854: временно скрываем логику повторного запроса
        // setPendingOperation(null);
        setIsOpen(false);
        // если пользователь не авторизовался и закрыл модалку
        if (needReloadRef.current) {
            // извлекаем orderId
            const orderId = extractOrderIdFromPathname(location.pathname);
            if (orderId) {
                // редиректим на страницу заказа
                history.replace(`/booking/${orderId}/order`);
            }
            else {
                // если не получилось вытащить orderId
                window.location.reload();
            }
            return;
        }
        // если пользватель авторизовался,
        // то просто перезагружаем страницу (остается в модуле возврата/обмена)
        history.replace(location.pathname + location.search);
    }, [history, location.pathname, location.search]);
    const onSuccess = useCallback(() => {
        // если пользователь успешно авторизовался, то не перезагружаем страницу при закрытии модального окна
        needReloadRef.current = false;
        // делаем задержку, чтобы пользователь успел увидеть сообщение об успешной авторизации
        setTimeout(() => {
            onClose();
        }, 2000);
    }, [onClose]);
    return (React.createElement(LoginFormModal, { modalProps: { isOpen, onClose, size: isMobile ? 'fullscreen' : 'medium' }, loginFormProps: {
            descriptionLoginForm: t('LoginForm_SecondaryAuthForRefund_Description'),
            descriptionWelcome: t('Welcome_SecondaryAuthForRefund_Description'),
            onSuccess,
            successDelay: 0
        } }));
};
export default AuthRequiredForSecondaryOps;
